document.addEventListener('DOMContentLoaded', function () {
  const tabsContainers = document.querySelectorAll('.b-icon-tabs');

  tabsContainers.forEach((container) => {
    const buttons = container.querySelectorAll('.tabs-navigation button');
    const tabContainer = container.querySelector('[x-ref="tabContainer"]');

    function activateTab(tabId) {
      buttons.forEach((btn) => {
        if (btn.id === tabId) {
          btn.classList.add('bg-blue-500', 'text-white');
          btn.classList.remove('bg-blue-50', 'text-blue-500');
        } else {
          btn.classList.remove('bg-blue-500', 'text-white');
          btn.classList.add('bg-blue-50', 'text-blue-500');
        }
        btn.blur(); // zruší focus po kliknutí
      });

      // Zobrazenie správneho obsahu tabov
      if (tabContainer) {
        const tabs = tabContainer.children;
        Array.from(tabs).forEach((tab) => {
          tab.style.display = tab.id === tabId ? 'block' : 'none';
        });
      }

      // Aktualizuj hash
      history.replaceState(null, null, `#${tabId}`);
    }

    // Inicializácia podľa hash alebo prvého tabu
    const initialHash = window.location.hash.replace('#', '');
    if (initialHash && container.querySelector(`#${initialHash}`)) {
      activateTab(initialHash);
    } else if (buttons.length > 0) {
      activateTab(buttons[0].id);
    }

    // Kliky na tlačidlá
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        activateTab(btn.id);
      });
    });

    // Zmeny hash (linky z iných sekcií)
    window.addEventListener('hashchange', () => {
      const hash = window.location.hash.replace('#', '');
      if (hash && container.querySelector(`#${hash}`)) {
        activateTab(hash);
      }
    });
  });
});
